import { lazy, Suspense } from 'react'
import { createBrowserRouter, Navigate } from 'react-router'
import { FEATURE_COMMUNICATION_CAMPAIGN } from '@m3-tech/boss-types'
import { CommunicationSidebarLayout } from '@/components/SidebarLayout'
import {
    FeatureGuardedRoute,
    RouteErrorBoundaryFallback,
    LoadingSpinner,
    ModuleLayout,
} from '@m3-tech/boss-ui'

const CommunicationHome = lazy(() => import('@/pages/CommunicationHome'))
const CommunicationDetail = lazy(() => import('@/pages/CommunicationDetail'))
const CommunicationNew = lazy(() => import('@/pages/CommunicationNew'))
const Campaigns = lazy(() => import('@/pages/Campaigns'))
const CampaignEdit = lazy(() => import('@/pages/CampaignEdit'))
const NotFound = lazy(() => import('@/pages/NotFound'))

export const router = createBrowserRouter([
    {
        path: '/',
        element: (
            <ModuleLayout
                moduleKey="communication"
                testIdBase="communication"
                fullHeight
                pagesOwnScroll
            />
        ),
        errorElement: <RouteErrorBoundaryFallback />,
        children: [
            {
                element: <CommunicationSidebarLayout />,
                children: [
                    {
                        index: true,
                        element: <Navigate to="/triggered" replace />,
                    },
                    {
                        path: 'triggered',
                        element: (
                            <Suspense fallback={<LoadingSpinner />}>
                                <CommunicationHome />
                            </Suspense>
                        ),
                    },
                    {
                        path: 'communication/new',
                        element: (
                            <Suspense fallback={<LoadingSpinner />}>
                                <CommunicationNew />
                            </Suspense>
                        ),
                    },
                    {
                        path: 'communication/:objectId',
                        element: (
                            <Suspense fallback={<LoadingSpinner />}>
                                <CommunicationDetail />
                            </Suspense>
                        ),
                    },
                    {
                        path: 'campaigns',
                        element: (
                            <FeatureGuardedRoute featureId={FEATURE_COMMUNICATION_CAMPAIGN}>
                                <Suspense fallback={<LoadingSpinner />}>
                                    <Campaigns />
                                </Suspense>
                            </FeatureGuardedRoute>
                        ),
                    },
                    {
                        path: 'campaigns/:campaignId',
                        element: (
                            <FeatureGuardedRoute featureId={FEATURE_COMMUNICATION_CAMPAIGN}>
                                <Suspense fallback={<LoadingSpinner />}>
                                    <CampaignEdit />
                                </Suspense>
                            </FeatureGuardedRoute>
                        ),
                    },
                ],
            },
            {
                path: '*',
                element: (
                    <Suspense fallback={<LoadingSpinner />}>
                        <NotFound />
                    </Suspense>
                ),
            },
        ],
    },
])
